import { render, staticRenderFns } from "./ViewPanelTickets.vue?vue&type=template&id=f9428718&scoped=true&"
import script from "./ViewPanelTickets.vue?vue&type=script&lang=js&"
export * from "./ViewPanelTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9428718",
  null
  
)

export default component.exports